__turbopack_context__.v({
  "SLogoContainer": "_0hUu2q_SLogoContainer",
});
